import styled from "styled-components";
import img from "../../assets/image/imgMap";

export const Sidebar = styled.div`
  width: 280px;
  background: white;
  margin: 0px 8px 8px 8px;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
`;

export const MainContent_ = styled.div`
  flex: 1;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden; /* Para que CardsWrapper maneje el scroll */
`;


export const SearchBar = styled.div`
  display: flex;
  // margin-bottom: 12px;
   margin: 0px 25px 0px 8px;
`;

export const Input = styled.input`
  flex: 3;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px 0 0 8px;
`;

export const ScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 10px;
`;

export const CardsWrapper_ = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(208px, 1fr));
  gap: 14px;
`;

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(208px, 1fr));
  gap: 16px;
  max-height: calc(100vh - 120px); /* Ajusta según tu header */
  overflow-y: auto;
  padding: 10px;
`;

export const Card = styled.div`
  background: white;
  padding: 12px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  font-size: var(--app-font-size);
`;


export const PdfThumbnail = styled.div`
  background: url(${img.pdf}) center center / cover no-repeat;
  height: 90px;
  border-radius: 6px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const Title = styled.h4`
  margin: 0 0 6px 0;
  font-size: var(--app-font-size);
`;

export const Metadata = styled.div`
  margin-bottom: 8px;
  color: #555;
`;

export const ButtonGroup = styled.div`
  margin-top: auto;
  display: flex;
  gap: 8px;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SubCheckboxGroup = styled.div`
  margin-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;